module.exports = __webpack_public_path__ + "dollar_white_regular.33d994c341a343284828f0e9f2a0ba59.svg";